import React, { useEffect, useState } from 'react';
import { Heading } from '../common/heading';
import Input from '../common/input';
import loadingAnimation from '../animation/loader.json';
import Lottie, { Options } from 'react-lottie';
import { useDebounce } from '../hook/useDebounce';

const defaultOptions: Options = {
	loop: true,
	autoplay: true,
	animationData: loadingAnimation,
	rendererSettings: {
		preserveAspectRatio: 'xMidYMid slice',
	},
};

export interface Notice {
	forename: string;
	date_of_birth: string;
	entity_id: string;
	nationalities: string[];
	name: string;
	_links: Links;
}

export interface Links {
	self: Images;
	images: Images;
	thumbnail?: Images;
}

export interface Images {
	href: string;
}

const DebounceInput: React.FC = () => {
	const [notices, setNotices] = useState<Notice[]>([]);
	const [search, setSearch] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const [isError, setIsError] = useState<boolean>(false);

	const debouncedSearch = useDebounce(search, 500);

	const handleSetSearch = (e: {
		target: { value: React.SetStateAction<string> };
	}) => {
		setSearch(e.target.value);
	};

	useEffect(() => {
		async function fetchData() {
			setLoading(true);
			setNotices([]);

			const data = await fetch(
				`https://ws-public.interpol.int/notices/v1/red?forename=${debouncedSearch}&resultPerPage=200`,
			)
				.then((res) => res.json())
				.catch((err) => {
					setLoading(false);
					setIsError(true);
				});

			setNotices(data._embedded.notices);
			setLoading(false);
		}
		if (debouncedSearch) {
			fetchData();
		}
	}, [debouncedSearch]);

	return (
		<div>
			<Heading
				text="Debounce Input"
				description="In this section, Debounced Search Input will be created."
			/>
			<Input
				type="search"
				placholder="Search"
				onChange={handleSetSearch}
				value={search}
			/>
			<div className="flex items-center flex-row gap-4 flex-wrap mt-10">
				{isError && (
					<h1 className="text-red-600 font-bold text-xl text-center">
						Something went wrong
					</h1>
				)}
				{notices.length === 0 && (
					<h1 className="text-gray-300 font-bold text-xl text-center">
						No Result Found
					</h1>
				)}
				{loading ? (
					<>
						<Lottie
							options={defaultOptions}
							width={150}
							ariaLabel="Loading Animation"
							title="Loding Animation"
						/>
					</>
				) : (
					<>
						{notices &&
							notices?.map((notice, idx) => {
								return (
									<div
										key={idx}
										className="border border-gray-700 hover:border-gray-600 flex flex-col p-3 items-center justify-center rounded-md shadow-xl"
									>
										{notice._links?.thumbnail?.href && (
											<img
												src={notice._links?.thumbnail?.href}
												title="Notice"
												alt="Notice"
												className="rounded-md w-[70px] h-[70px]"
											/>
										)}
										<div className="text-base font-bold">
											<p>{notice.forename}</p>
										</div>
										<p>{notice.date_of_birth}</p>
									</div>
								);
							})}
					</>
				)}
			</div>
		</div>
	);
};

export default DebounceInput;
